import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from '../general-components/Button';
import styles from './MriCode.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
// import { Button } from '../ui/Button';
import { useMediaQuery } from '../../hooks/useMediaQuery';

interface SerialCode {
    code: string;
}

const MRICode: React.FC<SerialCode> = ({ code }) => {
    const { t } = useTranslation();
    const [isCopied, setIsCopied] = useState(false);
    const matches = useMediaQuery('(min-width: 968px)');

    const [btnText, setBtnText] = useState(
        matches ? t('mriCode.button.mriCode', { code }) : code
    );

    const copyText = async (text: string) => {
        await navigator.clipboard.writeText(text);
    };

    const handleChangeCopied = () => {
        setBtnText(t('mriCode.button.copied'));
        setIsCopied(true);
        copyText(code);
    };

    useEffect(() => {
        const copyTextEffect = setTimeout(() => {
            setIsCopied(false);
            setBtnText(matches ? t('mriCode.button.mriCode', { code }) : code);
        }, 2000);
        return () => clearTimeout(copyTextEffect);
    }, [isCopied, matches, code, t]);

    return (
        <Button onClick={handleChangeCopied} type={ButtonType.action}>
            <FontAwesomeIcon icon={faCopy} />
            {btnText}
        </Button>
    );
};

export default MRICode;
